export const initialFilterStore = {
  streetAddress: [],
  city: [],
  stateProvince: [],
  postalCode: [],
  county: [],
  country: "",
  price: { minValue: '', maxValue: '', currency: '' },
  rentalPrice: { minValue: '', maxValue: '', currency: '' },
  soldPrice: { minValue: '', maxValue: '', currency: '' },
  amenities: {
    beds: { min: '', max: '' },
    bath: { min: '', max: '' },
    floors: { min: '', max: '' },
    parkingSpaces: { min: '', max: '' },
    rooms: { min: '', max: '' },
    units: { min: '', max: '' },
    HVAC: [],
    exterior: [],
    roofing: []
  },
  sizeUnits: {
    floorSize: { min: '', max: '', unit: '' },
    lotSize: { min: '', max: '', unit: '' }
  },
  requiredFields: [],
  mostRecentStatusDate: {
    startDate: '',
    endDate: ''
  },
  mostRecentStatusFirstDateSeen: {
    startDate: '',
    endDate: ''
  },
  mostRecentPriceDate: {
    startDate: '',
    endDate: ''
  },
  mostRecentRentalListPriceDate: {
    startDate: '',
    endDate: ''
  },
  mostRecentRentalStatusDate: {
    startDate: '',
    endDate: ''
  },
  mostRecentRentalStatusFirstDateSeen: {
    startDate: '',
    endDate: ''
  },
  mostRecentSoldPriceDate: {
    startDate: '',
    endDate: ''
  },
  recordRecency: {
    dateAdded: '',
    dateUpdated: ''
  },
  featureKeyword: {
    key: '',
    value: ''
  },
  description: {
    value: ''
  },
  people: {
    name: '',
    people_key: '',
    title: '',
    dateRange: {
      startDate: '',
      endDate: ''
    },
    currentOwnershipType: ''
  }
}

export const initialStore = {
  page: 1,
  isQueryLoading: false,
  address: '',
  propertyType: ['Any'],
  mostRecentStatus: ['Any'],
  dataResults: [],
  queryStore: '',
  downloadData: {
    downloadQueryStore: '',
    download_id: ''
  },
  newToken: ''
}
